import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react'

const PanelStepsContext = createContext<PanelStepsContextType | undefined>(
  undefined
)

export const PanelStepsProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [steps, setSteps] = useState<Step[]>([])
  const [currentStep, setCurrentStep] = useState<number | null>(null)

  const stepsSize = useMemo(() => {
    return steps.length || 0
  }, [steps])

  const isLastStep = useCallback(
    (step: number) => {
      const lastStepIndex = stepsSize - 1
      return step >= lastStepIndex
    },
    [stepsSize]
  )

  const prevStep = useCallback(() => {
    setCurrentStep(old => {
      return old >= 1 ? old - 1 : old
    })
  }, [])

  const nextStep = useCallback(() => {
    setCurrentStep(old => {
      const lastStepIndex = stepsSize - 1
      const nextStep = old + 1
      return nextStep <= lastStepIndex ? nextStep : old
    })
  }, [stepsSize])

  return (
    <PanelStepsContext.Provider
      value={{
        steps,
        setSteps,
        currentStep,
        setCurrentStep,
        nextStep,
        prevStep,
        stepsSize,
        isLastStep
      }}
    >
      {children}
    </PanelStepsContext.Provider>
  )
}

export const usePanelSteps = () => {
  const context = useContext(PanelStepsContext)
  if (!context) {
    throw new Error('usePanelSteps must be used within a PanelSteps.')
  }
  return context
}
